import { BasicModal } from "@components/modal/BasicModal"
import { FlexBox } from "@components/wrapper"
import { flex_center } from "@constants/styles"
import { useScreenSize } from "@lib/hooks/useScreenSize"
import clsx from "clsx"
import Image from "next/image"
import React, { useState } from "react"
import { FaTimes } from "react-icons/fa"
import { IoPlay } from "react-icons/io5"
import VideoPlayer from "./VideoPlayer"

interface Props {
  url: string
  thumbnail: string
  className?: string
  videoTitle?: string
}

export const PreviewPlayer = (props: Props) => {
  const { screenWidth } = useScreenSize()
  const [openPopup, setOpenPopup] = useState(false)

  const { url, thumbnail, videoTitle, className } = props

  function handleOpenVideo() {
    setOpenPopup(true)
  }

  function handleCloseVideo() {
    setOpenPopup(false)
  }

  if (url.includes("youtube")) {
    const regExp =
      /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=))([\w/-]{11})(?:\S+)?$/

    // Execute the regular expression and get the video ID
    const match = url.match(regExp)

    return (
      <>
        <div className="relative">
          <div className={clsx("sm:h-[40vw] h-[50vw] mx-2", className)}>
            <Image
              src={thumbnail}
              width={screenWidth * 0.67}
              height={screenWidth * 0.4}
              alt={videoTitle}
              className={clsx("w-full h-full object-cover", className)}
            />
          </div>
          <FlexBox className="absolute wh-full z-[5] top-0" justify="center" align="center">
            <FlexBox
              justify="center"
              align="center"
              className="backdrop-blur-md w-[74px] h-[74px] rounded-full"
              onClick={handleOpenVideo}
            >
              <div className={clsx("rounded-full bg-white w-[48px] h-[48px]", flex_center)}>
                <IoPlay className="sm:text-xl" />
              </div>
            </FlexBox>
          </FlexBox>
        </div>

        <BasicModal show={openPopup} onClose={handleCloseVideo}>
          <div className="relative sm:wh-max w-[100vw] h-[100vh]">
            <button
              className="absolute z-[1000] sm:-right-8 -right-2 sm:-top-8 top-8"
              onClick={handleCloseVideo}
            >
              <FaTimes className="sm:text-2xl text-white text-lg" />
            </button>

            <figure className="wh-full flex items-center justify-center">
              <iframe
                width={screenWidth > 576 ? screenWidth * 0.67 : screenWidth - 36}
                height={screenWidth > 576 ? screenWidth * 0.4 : screenWidth * 0.5}
                src={`https://www.youtube.com/embed/${match[1]}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
                className="left-0 top-0"
              />
            </figure>
          </div>
        </BasicModal>
      </>
    )
  } else {
    return (
      <VideoPlayer
        url={url}
        videoTitle={videoTitle ?? "Introduction Video"}
        className={className ?? "w-full h-auto"}
        thumbnail={thumbnail}
      />
    )
  }
}
